import React from "react";
import i18next from "i18next";

import english from "./i18n/english";
import korean from "./i18n/korean";
import spanish from "./i18n/spanish";
import ParentMessages from "./parent-message-page";

i18next.addResourceBundle("en", "ParentMessages", english);
i18next.addResourceBundle("es", "ParentMessages", spanish);
i18next.addResourceBundle("kr", "ParentMessages", korean);

export const ParentMessageRoutes = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: "parent-messages",
      element: <ParentMessages />,
    },
  ],
};
